export const PAGE_CONTENT_WIDTH = 728;